import { ChangeDetectionStrategy, Component, Inject, inject } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import {
  FORM_FIELD_COMMENT_TYPE_ICONS,
  FORM_FIELD_COMMENT_TYPES,
  FormFieldComment,
  FormFieldCommentForm,
  FormFieldCommentType,
} from "../comment.model";

export interface CommentDialogData {
  comment?: Partial<FormFieldComment> | null;
}

@Component({
  selector: "app-comment-dialog",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
  templateUrl: "./comment-dialog.component.html",
  styleUrl: "./comment-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CommentDialogComponent {
  private dialogRef =
    inject<MatDialogRef<CommentDialogComponent>>(MatDialogRef);

  readonly commentTypes: FormFieldCommentType[] = FORM_FIELD_COMMENT_TYPES;
  readonly commentTypeIcons = FORM_FIELD_COMMENT_TYPE_ICONS;

  form: FormGroup;
  readonly isEdit: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: CommentDialogData) {
    this.isEdit = !!data?.comment;
    this.form = new FormGroup(
      new FormFieldCommentForm(data?.comment ?? {}) as unknown,
    );
  }

  get canSave(): boolean {
    return this.form.valid;
  }

  save(): void {
    if (!this.canSave) {
      return;
    }
    const v = this.form.getRawValue();
    const comment = new FormFieldComment({
      uuid: v.uuid || null,
      title: v.title?.trim() || null,
      body: v.body?.trim() ?? "",
      type: v.type,
      defaultOpen: !!v.defaultOpen,
      canFold: !!v.canFold,
      showIcon: !!v.showIcon,
    });
    this.dialogRef.close(comment);
  }

  /** Removes the comment from the field entirely. */
  deleteComment(): void {
    this.dialogRef.close(null);
  }

  cancel(): void {
    this.dialogRef.close(undefined);
  }
}
